import { apiClient } from '@/shared/api';
import { UiSettings } from '@/entities/settings/models/types';
import { ChangePasswordRequest, ProfileData, UpdateProfileRequest, UpdateProfileResponse } from '../types';

// GET /profile/me - get current user profile
export const fetchMyProfile = async () => {
  const { data } = await apiClient.get<ProfileData>('/profile/me');
  return data;
};

// POST /profile/change-password - change current user password
export const changeMyPassword = async (payload: ChangePasswordRequest) => {
  const { data } = await apiClient.post<unknown>('/profile/change-password', payload);
  return data;
};

// PUT /profile/update - update current user profile
export const updateMyProfile = async (payload: UpdateProfileRequest) => {
  const { data } = await apiClient.put<UpdateProfileResponse>('/profile/update', payload);
  return data;
};

// PUT /profile/ui-settings - сохранение настроек интерфейса пользователя
export const updateUiSettings = async (uiSettings: UiSettings) => {
  const { data } = await apiClient.put<{ uiSettings: UiSettings }>('/profile/ui-settings', {
    uiSettings,
  });
  return data;
};
